import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  bulkRegisterTeachers,
  teachersPath,
  fetchTeachers,
  BULK_REGISTER_TEACHERS_SUCCESS_MESSAGE,
  FETCH_TEACHERS_SUCCESS,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import TeacherSpreadSheet from "../../../templates/manager/TeacherSpreadSheet";
import { ITeacherForRegister } from "../../../state";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

const BulkRegisterTeachers = () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [fetched, setFetched] = React.useState(false);
  const history = useHistory();

  React.useEffect(() => {
    if (state.success_message === BULK_REGISTER_TEACHERS_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(teachersPath);
    }
  }, [history, dispatch, state.success_message]);

  React.useEffect(() => {
    if (state.lastAction === FETCH_TEACHERS_SUCCESS) {
      setFetched(true);
    }
  }, [state.lastAction]);

  const bulkRegisterTeachersFunc = React.useCallback(
    (teachers: ITeacherForRegister[]) => {
      dispatch(peep(bulkRegisterTeachers(teachers)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchTeachers());
    return () => dispatch(clearErrorMessage());
  }, [dispatch]);

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.teachers, to: teachersPath }]}
        currentTitle={titles.bulkRegisterTeachers}
      />
      {fetched && (
        <TeacherSpreadSheet
          title={titles.bulkRegisterTeachers}
          calling={calling}
          error={state.error}
          teachers={state.teachers}
          save={bulkRegisterTeachersFunc}
        />
      )}
    </div>
  );
};

export default BulkRegisterTeachers;
